import React from 'react';
import { classNames } from '../../utils/classNames';
import { useI18n } from '../../hooks/useI18n';

export const ImageEmptyState = ({
  catalog = [],
  selectedTemplateId,
  onSelectTemplate,
  composer
}) => {
  const { t, language } = useI18n();
  const allTemplates = catalog.flatMap((category) => category.templates || []);
  const styleTemplates = allTemplates.slice(0, 8);
  const ideaTemplates = allTemplates.slice(0, 6);

  return (
    <div className="pb-10">
      <div className="mb-10 flex flex-col items-center px-4 pt-6">
        <h1 className="mb-3 text-center text-3xl font-bold tracking-tight text-neutral-950 dark:text-white sm:text-4xl">
          {t('imageSectionTitle')}
        </h1>
        <p className="mb-8 max-w-xl text-center text-sm text-neutral-500">{t('imageSectionHint')}</p>
        <div className="w-full">{composer}</div>
        <p className="mt-4 text-center text-sm text-neutral-400">{t('imageEmptyBody')}</p>
      </div>

      {styleTemplates.length > 0 ? (
        <section className="mb-10">
          <h2 className="mb-4 px-1 text-lg font-semibold text-neutral-950 dark:text-white">
            {t('imageStylesTitle')}
          </h2>
          <div className="flex gap-3 overflow-x-auto pb-2">
            {styleTemplates.map((template) => (
              <button
                key={template.id}
                type="button"
                onClick={() => onSelectTemplate?.(template)}
                className={classNames(
                  'w-[140px] shrink-0 overflow-hidden rounded-2xl text-start transition',
                  selectedTemplateId === template.id
                    ? 'ring-2 ring-neutral-950 dark:ring-white'
                    : 'hover:opacity-90'
                )}
              >
                <img
                  src={template.thumbnailUrl}
                  alt={language === 'fa' ? template.titleFa : template.titleEn}
                  className="aspect-[3/4] w-full object-cover"
                  loading="lazy"
                />
                <div className="bg-[#F3F4F6] px-2.5 py-2 text-xs font-medium text-neutral-800 dark:bg-neutral-900 dark:text-neutral-200">
                  {language === 'fa' ? template.titleFa : template.titleEn}
                </div>
              </button>
            ))}
          </div>
        </section>
      ) : null}

      {ideaTemplates.length > 0 ? (
        <section>
          <h2 className="mb-4 px-1 text-lg font-semibold text-neutral-950 dark:text-white">
            {t('imageIdeasTitle')}
          </h2>
          <div className="grid gap-3 sm:grid-cols-2">
            {ideaTemplates.map((template) => (
              <button
                key={`idea-${template.id}`}
                type="button"
                onClick={() => onSelectTemplate?.(template)}
                className={classNames(
                  'flex items-center gap-3 rounded-2xl bg-[#F3F4F6] p-3 text-start transition hover:bg-[#E8E8EA] dark:bg-neutral-900 dark:hover:bg-neutral-800',
                  selectedTemplateId === template.id && 'ring-2 ring-neutral-950 dark:ring-white'
                )}
              >
                <img
                  src={template.thumbnailUrl}
                  alt=""
                  className="h-14 w-14 shrink-0 rounded-xl object-cover"
                  loading="lazy"
                />
                <span className="text-sm font-medium leading-6 text-neutral-800 dark:text-neutral-100">
                  {language === 'fa' ? template.titleFa : template.titleEn}
                </span>
              </button>
            ))}
          </div>
        </section>
      ) : null}
    </div>
  );
};
